import styled from "styled-components";

export const PageContainer = styled.div`
  max-width: 560px;
  margin: 24px auto;
  padding: 0 16px;
`;

/** Same card style as dashboard "Suggested for you" */
export const SuggestionsCard = styled.div`
  background-color: white;
  box-shadow: 1px 1px 6px 0px #401a0f40;
  border-radius: 40px;
  padding: 24px;

  h2 {
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;
    margin: 0;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;

  .nav-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    margin: -4px 0 0 -4px;
    color: #401a0f;
  }

  .nav-btn:hover {
    opacity: 0.8;
  }
`;

export const TabContainer = styled.div`
  overflow-y: auto;
`;
